import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import BackgroundFx from "./components/BackgroundFx";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import ScrollToTop from "./components/ScrollToTop";
import ConsentBanner from "./components/ConsentBanner";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop behavior="auto" />
      <div className="relative z-10 min-h-screen text-fg">
        <BackgroundFx />
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
          </Routes>
        </main>
        <ConsentBanner />
        <Footer />
      </div>
    </BrowserRouter>
  );
}
